import { Navigate, Outlet } from "react-router";
import { Card, Grid, VStack } from "@chakra-ui/react";
import { CreateOrderFormProvider } from "@/features/order/create";
import { InvitationAcceptPrompt } from "@/features/invitation/accept-prompt";
import { PendingInvitationsBanner } from "@/features/invitation/pending/ui/pending-invitations-banner";

import { SideBar } from "@widgets/sidebar";
import { UrlNotificationBlock } from "@shared/ui/notification-block";
import { useAuthenticationContext } from "@app/auth/use-authentication-context";

interface Props {
  children?: React.ReactNode;
}

export const OutletLayout: React.FC<Props> = ({ children }) => {
  const { loggedIn } = useAuthenticationContext();

  if (!loggedIn) return <Navigate to="/login" />;

  return (
    <Grid
      templateColumns={{ md: "1fr 10fr", lg: "2fr 10fr", base: "12fr" }}
      gap={{ md: 2, base: 0 }}
      p={{ md: 2, base: 0 }}
      h="full"
      w="full"
    >
      <CreateOrderFormProvider onCompleted={void 0}>
        <Card.Root
          h="full"
          display={{ base: "none", md: "flex" }}
          borderWidth={{ base: 0, md: 1 }}
        >
          <VStack w="full" h="full">
            <SideBar />
          </VStack>
        </Card.Root>
        <Card.Root
          h="calc(100vh - 24px)"
          p={{ base: 0, md: 4 }}
          borderWidth={{ base: 0, md: 1 }}
        >
          <VStack rounded="md" w="full" h="full">
            <UrlNotificationBlock px={{ base: 4, md: 0 }} mt={2} />
            <InvitationAcceptPrompt />
            <PendingInvitationsBanner />
            {children || <Outlet />}
          </VStack>
        </Card.Root>
      </CreateOrderFormProvider>
    </Grid>
  );
};
